import React, { useRef } from 'react';
import { Edviron } from '../../../../../../util/EdvironSdk';
import { toast } from 'react-toastify';
// import useScript from '../../../../../../hooks/useScript';

declare global {
	interface Window {
		Edviron?: new (env: string) => {
			collect_now: (opts: { school_id: string; student_id: string }) => void;
		};
	}
}

export default function CollectFeeButton({ school_id, student_id }: { school_id: string; student_id: string }) {
	// typed ref for the Edviron instance
	const edviron = new Edviron('PRODUCTION');
	const handleClick = async () => {
		if (!school_id || !student_id) {
			toast.error('School ID or Student ID is missing');
			return;
		}
		edviron.collect_now({
			school_id: school_id,
			student_id: student_id,
		});
	};

	return (
		<button
			id='payButton'
			onClick={handleClick}
			className={` py-1.5 text-edvion_black text-base disabled:bg-slate-50  bg-indigo-200 px-4 rounded-[8px] `}
		>
			Collect Fee
		</button>
	);
}
